import { render } from "./WishesModal.vue?vue&type=template&id=fa262c74&scoped=true"
import script from "./WishesModal.vue?vue&type=script&lang=js"
export * from "./WishesModal.vue?vue&type=script&lang=js"

import "./WishesModal.vue?vue&type=style&index=0&id=fa262c74&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Downloads\\Kad Adeeb\\adeebxhanna\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa262c74"]])

export default __exports__